module.exports = __webpack_public_path__ + "img/gift.117665d3.svg";